import { render, staticRenderFns } from "./AddClient.vue?vue&type=template&id=74cbb5df&"
import script from "./AddClient.vue?vue&type=script&lang=js&"
export * from "./AddClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports